"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.followButtonStyles = exports.toggleButtonStyles = exports.buttonSelectedStyles = exports.buttonVariantSkin = exports.buttonVariantStyles = exports.buttonSizeStyles = exports.buttonBaseStyles = exports.interactiveControlStyles = void 0;
const lit_1 = require("lit");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
/** button 태그뿐 아니라 mm-hashtag-link 등 a 기반 파생 컴포넌트도 같은 스킨을 그대로 가져다 쓰도록 공용 상호작용 선택자로 잡는다. */
exports.interactiveControlStyles = (0, lit_1.css) `
  ${shared_styles_1.interactiveElement} {
    &:focus-visible {
      ${shared_styles_1.focusRingStyles};
    }

    &:disabled {
      ${shared_styles_1.disabledStyles};
    }
  }
`;
/**
 * 모든 버튼형 컴포넌트가 공유하는 기반 스타일.
 * 구조(레이아웃·크기·간격·타이포)와 기본 스킨, 상호작용 상태(focus·active·disabled)를 포함한다.
 */
exports.buttonBaseStyles = [
    exports.interactiveControlStyles,
    (0, lit_1.css) `
    :host {
      --button-height: var(--size-32);
      --button-min-width: 4rem;
      --button-border: var(--border-transparent);
      --button-padding-inline: var(--space-3);
      --button-border-radius: var(--radius);
      --button-background-color: var(--background-subtle-color);
      --button-text-size: inherit;
      --button-text-weight: var(--font-weight-normal);
      --button-text-color: var(--foreground-color);
      --button-width: max-content;
    }

    :host([full-width]) :is(button, a) {
      width: 100%;
    }

    :is(button, a) {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      /* max-content for trailing icons */
      width: var(--button-width);
      gap: var(--space-1);
      height: var(--button-height);
      padding: 0 var(--button-padding-inline);
      border: var(--button-border);
      border-radius: var(--button-border-radius);
      background: var(--button-background-color);
      box-sizing: border-box;

      color: var(--button-text-color);
      font-family: var(--font-family);
      font-size: var(--button-text-size);
      font-weight: var(--button-text-weight);
      text-transform: capitalize;

      &:hover:not(:disabled) {
        --button-border: var(--border);
      }
    }
  `,
];
/** mm-button 크기 변형. */
exports.buttonSizeStyles = (0, lit_1.css) `
  :is(button, a) {
    min-width: var(--button-min-width);
  }
  :host([size='large']) :is(button, a) {
    --button-height: var(--size-48);
  }
`;
const buttonVariantTokens = {
    primary: {
        '--button-background-color': 'var(--primary-color)',
        '--button-text-color': 'var(--foreground-on-primary-color)',
    },
    secondary: {
        '--button-background-color': 'var(--primary-subtle-color)',
        '--button-text-color': 'var(--primary-color)',
    },
    tertiary: {
        '--button-text-color': 'var(--foreground-color)',
    },
    ghost: {
        '--button-background-color': 'transparent',
        '--button-text-color': 'var(--primary-color)',
    },
    danger: {
        '--button-background-color': 'var(--danger-color)',
        '--button-text-color': 'var(--foreground-on-primary-color)',
    },
};
/** mm-button 색 변형(variant). */
exports.buttonVariantStyles = (0, lit_1.css) `
  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('variant', buttonVariantTokens))}
`;
/** 자체 button을 렌더하는 시맨틱 컴포넌트가 variant 하나를 골라 스킨으로 얹는 선언. 얹을 선택자 안에 펼쳐 쓴다. */
const buttonVariantSkin = (variant) => (0, lit_1.unsafeCSS)((0, utils_1.buildDeclarations)(buttonVariantTokens[variant]));
exports.buttonVariantSkin = buttonVariantSkin;
/** 누름 상태는 표준 aria-pressed로 표현하므로, 스킨도 해당 attribute selector를 단일 기준으로 둔다. */
exports.buttonSelectedStyles = (0, lit_1.css) `
  button[aria-pressed='true'] {
    --button-background-color: var(--interaction-selected-background-color);
    --button-text-color: var(--interaction-selected-foreground-color);
    border-color: var(--interaction-selected-border-color);
  }
`;
/** mm-toggle-button 비선택 스킨. radius는 그룹이 모서리를 묶도록 토큰으로 노출한다. */
exports.toggleButtonStyles = (0, lit_1.css) `
  :host {
    display: inline-flex;

    --toggle-button-border-radius: var(--radius);
  }

  button {
    width: 100%;
    border-radius: var(--toggle-button-border-radius);
  }
`;
/** mm-follow-button 비선택 스킨(팔로우 = primary). */
exports.followButtonStyles = (0, lit_1.css) `
  :host {
    display: inline-flex;
  }

  button {
    ${(0, exports.buttonVariantSkin)('primary')};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnV0dG9uLnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImJ1dHRvbi5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQW9DO0FBSXBDLCtEQUFpRztBQUNqRyxtQ0FBc0Y7QUFFdEYsMEZBQTBGO0FBQzdFLFFBQUEsd0JBQXdCLEdBQUcsSUFBQSxTQUFHLEVBQUE7SUFDdkMsa0NBQWtCOztRQUVkLCtCQUFlOzs7O1FBSWYsOEJBQWM7OztDQUdyQixDQUFBO0FBRUQ7OztHQUdHO0FBQ1UsUUFBQSxnQkFBZ0IsR0FBRztJQUM5QixnQ0FBd0I7SUFDeEIsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQTBDRjtDQUNGLENBQUE7QUFFRCx1QkFBdUI7QUFDVixRQUFBLGdCQUFnQixHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7O0NBT2xDLENBQUE7QUFFRCxNQUFNLG1CQUFtQixHQUFtQztJQUMxRCxPQUFPLEVBQUU7UUFDUCwyQkFBMkIsRUFBRSxzQkFBc0I7UUFDbkQscUJBQXFCLEVBQUUsb0NBQW9DO0tBQzVEO0lBQ0QsU0FBUyxFQUFFO1FBQ1QsMkJBQTJCLEVBQUUsNkJBQTZCO1FBQzFELHFCQUFxQixFQUFFLHNCQUFzQjtLQUM5QztJQUNELFFBQVEsRUFBRTtRQUNSLHFCQUFxQixFQUFFLHlCQUF5QjtLQUNqRDtJQUNELEtBQUssRUFBRTtRQUNMLDJCQUEyQixFQUFFLGFBQWE7UUFDMUMscUJBQXFCLEVBQUUsc0JBQXNCO0tBQzlDO0lBQ0QsTUFBTSxFQUFFO1FBQ04sMkJBQTJCLEVBQUUscUJBQXFCO1FBQ2xELHFCQUFxQixFQUFFLG9DQUFvQztLQUM1RDtDQUNGLENBQUE7QUFFRCwrQkFBK0I7QUFDbEIsUUFBQSxtQkFBbUIsR0FBRyxJQUFBLFNBQUcsRUFBQTtJQUNsQyxJQUFBLGVBQVMsRUFBQyxJQUFBLDJCQUFtQixFQUFDLFNBQVMsRUFBRSxtQkFBbUIsQ0FBQyxDQUFDO0NBQ2pFLENBQUE7QUFFRCw0RUFBNEU7QUFDckUsTUFBTSxpQkFBaUIsR0FBRyxDQUFDLE9BQXlDLEVBQUUsRUFBRSxDQUM3RSxJQUFBLGVBQVMsRUFBQyxJQUFBLHlCQUFpQixFQUFDLG1CQUFtQixDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQTtBQUQvQyxRQUFBLGlCQUFpQixxQkFDOEI7QUFFNUQsNEVBQTRFO0FBQy9ELFFBQUEsb0JBQW9CLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7OztDQU10QyxDQUFBO0FBRUQsK0RBQStEO0FBQ2xELFFBQUEsa0JBQWtCLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7O0NBV3BDLENBQUE7QUFFRCw4Q0FBOEM7QUFDakMsUUFBQSxrQkFBa0IsR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7O01BTS9CLElBQUEseUJBQWlCLEVBQUMsU0FBUyxDQUFDOztDQUVqQyxDQUFBIn0=